export const sumAssignedBudgetTotal = (budgets = []) => {
  return budgets.reduce((total, budget) => {
    const hasMetadataAssignment = Boolean(budget?.metadata?.familyMemberId);
    const hasLinkedUserAssignment = Boolean(budget?.linkedUserId);

    if (hasMetadataAssignment || hasLinkedUserAssignment) {
      return total + Number(budget?.totalBudget || 0);
    }

    const assignedCategories = (budget?.categories || []).filter((category) => category?.familyMemberId);
    if (!assignedCategories.length) {
      return total;
    }

    const budgetTotal = Number(budget?.totalBudget || 0);
    const categoriesSum = assignedCategories.reduce((categorySum, category) => {
      const amount = category?.isPercentage
        ? ((Number(category?.amount || 0) / 100) * budgetTotal)
        : Number(category?.amount || 0);
      return categorySum + amount;
    }, 0);

    return total + categoriesSum;
  }, 0);
};

export async function calculateDailyAllowance(budgets) {
  return sumAssignedBudgetTotal(Array.isArray(budgets) ? budgets : []);
}
